import { createAction } from 'signin-app/redux/helpers';
const domain = 'CHILD';
export const { action: fetchChild, success: fetchChildSuccess, failed: fetchChildFailed, } = createAction(`${domain}/FETCH_CHILD`, (accessToken, childId) => ({ accessToken, childId }), (response) => ({ response }), (error) => ({ error }));
